import { DateTime } from 'luxon';

const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const formatDate = (orderDate: string): string => {
	const dt = DateTime.fromISO(orderDate, { zone: BROWSER_TZ });
	const sameYear = dt.year === DateTime.now().year;
	return dt.toFormat(sameYear ? 'EEE, MMM d, h:mm a' : 'EEE, MMM d, yyyy, h:mm a');
};

/**
 * How far ahead of the show start the doors open when the show carries no door time of its own.
 * Also the lead `useShowScheduleSync` preserves for such a show when the manager moves the start.
 */
export const DEFAULT_DOOR_LEAD_MS = 30 * 60 * 1000;

/**
 * The Open-Doors default: the standard lead before the show start. Returns null when the start is
 * missing or invalid, so a NaN date never propagates into the schema-validated `door_time` field — an
 * Invalid Date there surfaces as the schema's "Invalid Date" typeError and latches the Save button
 * disabled.
 *
 * Lives here (common, below both consumers) so the show-dashboard GeneralSection and the EditEvent
 * sub-page share one definition without either reaching across the feature tree.
 */
export const defaultDoorTime = (startDate: Date | null | undefined): Date | null => {
	if (!startDate || isNaN(startDate.getTime())) return null;
	return new Date(startDate.getTime() - DEFAULT_DOOR_LEAD_MS);
};
